import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ORDERSPAGE_LEGACY_FIELD_ORDER = [
  
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  ordersPageDescriptor: _generatedOrdersPageDescriptor,
  ordersPageBlocDefinition,
  ordersPageDashboardLayout,
  ordersPageConfig,
  ordersPageResolveConfig,
  ordersPageProperties,
} = doodBlockConfig(
  {
    name: "Orders list page",
    internal_name: "Orders list page",
    url: "orders",
    defaultParent: [/^Main Layout$/i],
    componentType: 'OrdersPageComponent',
    category: 'page',
    description: "Orders list page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.orders-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
        defaultBlocks: [
          { id: 'header-block', type: 'HeaderBlockComponent' },
          { id: 'orders-block', type: 'OrdersPageBlockComponent' },
        ],
      },
      {
        key: 'footer',
        name: "pages.blocks.orders-page.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["BigFooterBlock", "LegalsFooterBlock", "HtmlBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["body", "footer"],
          },
        ],
      },
    ],
  })
);

export function ordersPageDescriptor(): IBlockDescriptor;
export function ordersPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function ordersPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedOrdersPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedOrdersPageDescriptor, ordersPageProperties, fieldOrder);
}

export {
  ordersPageBlocDefinition,
  ordersPageDashboardLayout,
  ordersPageProperties,
  ordersPageConfig,
  ordersPageResolveConfig,
};

export type OrdersPageConfig = typeof ordersPageConfig;
